import { FC } from 'react';
import classNames from 'classnames';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import { ProcessedAnalyzedMove } from '../../types';
import { Score } from '../Score';
import { colorStyles, contentPaddingStyles } from '../../styles.css';
import {
  containerStyles,
  sectionStyles,
  titleStyles,
  imageStyles,
  textStyles,
  bestMoveSectionStyles,
  hiddenStyles,
} from './styles.css';

type Props = {
  move: ProcessedAnalyzedMove;
};

const MoveFeedback: FC<Props> = ({ move }) => {
  if (!move.grade) {
    return null;
  }

  return (
    <div className={classNames(contentPaddingStyles, containerStyles)}>
      <div className={sectionStyles}>
        <div className={classNames(titleStyles, colorStyles[move.grade])}>
          <img className={imageStyles} src={`/assets/move-grade-images/${move.grade}-move.svg`} />
          <p className={textStyles}>{t(`analysis.san.${move.grade!}`, { san: move.san })}</p>
        </div>

        <Score value={move.eval!} />
      </div>

      {move.best && (
        <div
          className={classNames(sectionStyles, bestMoveSectionStyles, { [hiddenStyles]: move.san === move.best.san })}
          aria-hidden={move.san === move.best.san}
        >
          <div className={classNames(titleStyles, colorStyles.best)}>
            <img className={imageStyles} src={`/assets/move-grade-images/best-move.svg`} />
            <p className={textStyles}>{t(`analysis.san.best`, { san: move.best.san })}</p>
          </div>

          <Score value={move.best.eval!} />
        </div>
      )}
    </div>
  );
};

export default MoveFeedback;
